import { restClient } from '@/Core'

/**
 * Повернення видаленого завдання (`POST /services/tasks/{uuid}/restore`).
 *
 * Право має лише адміністратор, і воно існує тільки на видаленому завданні —
 * бек віддає його в `_permissions.restore`, фронт лише показує дію.
 */
export const RestoreTaskTask = async (uuid: string): Promise<void> => {
    await restClient.post(`/services/tasks/${uuid}/restore`, { json: {} })
}
